const config = () => {
  const {
    NODE_ENV,
    BASE_URL,
    VUE_APP_HOST,
    VUE_APP_PROTOCOL,
    VUE_APP_HOST_BUSINESS,
    VUE_APP_HOST_ADMIN,
    VUE_APP_HOST_IDENTITY,
    VUE_APP_HOST_SIGNALR,
    VUE_APP_HOST_CURRENT
  } = process.env
  if (NODE_ENV === 'development') {
    return {
      business: `${VUE_APP_PROTOCOL}://${VUE_APP_HOST}${VUE_APP_HOST_BUSINESS}`,
      admin: `${VUE_APP_PROTOCOL}://${VUE_APP_HOST}${VUE_APP_HOST_ADMIN}`,
      identity: `${VUE_APP_PROTOCOL}://${VUE_APP_HOST}${VUE_APP_HOST_IDENTITY}`,
      signalR: `${VUE_APP_PROTOCOL}://${VUE_APP_HOST}${VUE_APP_HOST_SIGNALR}`,
      current: `${VUE_APP_PROTOCOL}://${VUE_APP_HOST}${VUE_APP_HOST_CURRENT}`
    }
  } else {
    return {
      business: `${VUE_APP_HOST_BUSINESS}`,
      admin: `${VUE_APP_HOST_ADMIN}`,
      identity: `${VUE_APP_HOST_IDENTITY}`,
      signalR: `${VUE_APP_HOST_SIGNALR}`,
      current: `${BASE_URL}`
    }
  }
}

export {
  config
}
